import React from 'react';

const BotPreview = () => {
  return <h1>Bot Preview</h1>;
};

export default BotPreview;
